export default __webpack_public_path__ + "static/media/3DShape_04.d98c7551.png";